<!-- This file is auto-generated don't edit it! -->
<h1 id="preview">Preview</h1>
<p><ui-button-group-docs-preview></ui-button-group-docs-preview></p>
<h1 id="description">Description</h1>
<p>Button group used in Bannerflow. The only difference between the default and pre selected is that the selectedButton has a string value, that connects to on of the buttonOptions value.</p>
<h1 id="usage">Usage</h1>
<pre><code class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ui-button-group</span>
    [<span class="hljs-attr">options</span>]=<span class="hljs-string">"buttonOptions"</span>
    [<span class="hljs-attr">value</span>]=<span class="hljs-string">"selectedButton"</span>
    (<span class="hljs-attr">change</span>)=<span class="hljs-string">"updateButtonToggle($event)"</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ui-button-group</span>&gt;</span></code></pre>
<h1 id="inputs">Inputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
<tbody><tr>
<td align="left">options</td>
<td align="left">Options array, needs to be the type UIButtonToggleOption</td>
</tr>
<tr>
<td align="left">value</td>
<td align="left">The default selected value, that matches the value in the options. If null, nothing will be selected.</td>
</tr>
</tbody></table>
<h1 id="outputs">Outputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
<tbody><tr>
<td align="left">valueChange</td>
<td align="left">Value of whatever is selected.</td>
</tr>
</tbody></table>
